import { useContext } from 'react';
import { ThemeContext } from '@/context/themeContext';
import type { ThemeContextValue } from '@/context/themeTypes';

export function useTheme(): ThemeContextValue {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
}
